import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'
import onClickOutside from 'react-onclickoutside'
import {
  _DropdownUl,
  _ArrowContainer,
  _Title,
  _WithTitleContainer,
  _CurrentVal,
} from './styles'

class CalcOptionDropdown extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showDropdown: false,
      currentVal: props.currentVal,
    }
  }
  static getDerivedStateFromProps(props, state) {
    if(props.currentVal !== state.currentVal) {
      return {
        showDropdown: false,
        currentVal: props.currentVal,
      }
    }
    return null
  }
  componentWillUnmount() {
    clearTimeout(this.timeout)
  }
  openDropDown = () => {
    this.setState({
      showDropdown: !this.state.showDropdown,
    })
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  handleClickOutside() {
    this.timeout = setTimeout(() => {
      this.setState({
        showDropdown: false,
      })
    }, 150)
  }
  renderArrowContainer = (label, type, showBorder) => (
    <_ArrowContainer
      resultType={type === 'Result'}
      onClick={this.openDropDown}
      showBorder={showBorder}
    >
      <div>
        {
          <_CurrentVal>{label}</_CurrentVal>
        }
        <SvgIcon name="#icon-arrow" width="10" height="10" />
      </div>
    </_ArrowContainer>
  )

  render() {
    const { label, position = '', type = 'Input', title = '', showBorder = false } = this.props
    if(!this.props.children) return null
    const arrowContainer = this.renderArrowContainer(label, type, showBorder)
    return (
      <div>
        {title ? (
          <_WithTitleContainer>
            <_Title>{title}</_Title>
            {arrowContainer}
          </_WithTitleContainer>
        ) : arrowContainer}

        <_DropdownUl
          show={this.state.showDropdown}
          top={position === 'Top'}
          widthTitle={title}
        >
          {this.state.showDropdown ? this.props.children : ''}
        </_DropdownUl>
      </div>
    )
  }
}

CalcOptionDropdown.propTypes = {
  currentVal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  position: PropTypes.oneOf(['Top']),
  type: PropTypes.oneOf(['Input', 'Frequency', 'Result']),
  title: PropTypes.string,
  label: PropTypes.string,
  showBorder: PropTypes.bool,
}

export default onClickOutside(CalcOptionDropdown)
